module.exports = "/packs/media/images/icons/calendarmoney-20919b92e106a7ee0bc516beb0c0b048.png";